<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useReviewReportStore } from '@/store';

const { clinicianMinutes } = storeToRefs(useReviewReportStore());

const provided = computed(() => new Intl.NumberFormat().format(clinicianMinutes.value.data.provided || 0));

const assigned = computed(() => new Intl.NumberFormat().format(clinicianMinutes.value.data.assigned || 0));
</script>

<template>
  <div class="p-3 surface-100 border-round-xl">
    <div class="flex align-items-center>">
      <h3 class="flex-1 text-base text-color-secondary mb-2">Service Provider Minutes</h3>
      <Icon
        v-tooltip.left="
          'Provided minutes are based on documented events. Assigned minutes are the total minutes assigned to service providers. '
        "
        name="info"
        class="text-gray-400 text-base cursor-pointer"
      />
    </div>
    <div class="flex gap-2">
      <div class="p-2 border-round bg-white">
        <div class="text-color-gray text-sm">Provided</div>
        <Skeleton v-if="clinicianMinutes.loading" height="1rem" class="mt-1" />
        <div v-else class="text-color-green text-lg font-bold" v-text="provided" />
      </div>
      <div class="p-2 border-round bg-white hidden">
        <div class="text-color-gray text-sm">Assigned</div>
        <Skeleton v-if="clinicianMinutes.loading" height="1rem" class="mt-1" />
        <div v-else class="text-color-blue text-lg font-bold" v-text="assigned" />
      </div>
    </div>
  </div>
</template>
